import { Box, Typography, styled } from "@mui/material";
import { theme } from '../../provider/ThemeProvider'

type HeadlineProps = {
  title: string,
};

export const Headline = ({ title }: HeadlineProps) => {
  return (
    <StyledHeadlineBox
      sx={{
        backgroundColor: "#4B4B4B",
        width: 1
      }}
    >
      <StyledPrintTypography variant="body1" sx={{
          py: 1,
          pl: 1,
          fontWeight: 600,
          color: theme.palette.text.secondary}}>
          {title}
      </StyledPrintTypography>
    </StyledHeadlineBox>
  );
};

const StyledHeadlineBox = styled(Box)`
  @media print {
  }
`

const StyledPrintTypography = styled(Typography)`
  font-size: 12px;
`

const SubHeadlineBox = styled(Box)`
  margin-top: 0px;
`

export const SubHeadline = ({ title }: HeadlineProps) => {
  return (
    <SubHeadlineBox
      sx={{
        width: 'fit-content',
      }}
      mt={4}
      mb={2}
    >
      <Typography variant="body1" sx={{
          borderBottom: "1px solid #529BC5",
          fontSize: "14px",
          lineHeight: "1.6",
          color: theme.palette.text.primary}}>
          {title}
      </Typography>
    </SubHeadlineBox>
  );
};

type ResultHeadlineProps = {
  rank: string,
  result: string,
  lang: 'ja' | 'en'
}

export const ResultHeadline = (props: ResultHeadlineProps) => {
  const lang = props.lang;
  return (
    <Container>
      <Typography variant="body1"  component={"div"}
      sx={{
        fontSize: "9px",
        fontWeight: 700,
        paddingRight: '12px',
        color: theme.palette.text.secondary}}
      >{lang === "ja" ? "総合判定" : "Inspection Result"}</Typography>
      <CircleText text={props.rank}/>
        <Typography variant="body1" sx={{
          fontWeight: 600,
          fontSize: "12px",
          paddingLeft: '14px',
          color: theme.palette.text.secondary}}>
          {props.result}
      </Typography>
      <Box
        display={"flex"}
        sx={{
          paddingLeft: '40px',
        }}
      >  
       <Typography variant="body1" sx={{
          paddingRight: '12px',
          fontSize: "9px",
          fontWeight: 500,
          color: theme.palette.text.secondary}}>{lang === "ja" ? "A: 良好" : "A : Good"}</Typography>
        <Typography variant="body1" sx={{
          paddingRight: '12px',
          fontSize: "9px",
          fontWeight: 500,
          color: theme.palette.text.secondary}}>{lang === "ja" ? "B: 差支えなし" : "B : Without exception"}</Typography>
        <Typography variant="body1" sx={{
          paddingRight: '12px',
          fontSize: "9px",
          fontWeight: 500,
          color: theme.palette.text.secondary}}>{lang === "ja" ?"C: 要経過観察、要生活改善" : "C : Lifestyle habit improvement and observation are necessary."}</Typography>
        <Typography variant="body1" sx={{
          paddingRight: '12px',
          fontSize: "9px",
          fontWeight: 500,
          color: theme.palette.text.secondary}}>{lang === "ja" ?"D: 要精密検査、要受診" : "D : Detailed examination needed. Have a medical examination."}</Typography>
      </Box>
    </Container>
  );
};

const Container = styled(Box)`
  background-color: #4B4B4B;
  padding: 6px 12px;
  display: flex;
  align-items: center;
`

const CircleContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 38px;
  width: 38px;
`;

const Circle = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: white;
  height: 38px;
  width: 38px;
`;

const Text = styled('span')`
  color: #353535;
  font-size: 20px;
  line-height: 1.5;
  font-weight: 700;
`;

type CircleTextProps = {
  text: string,
}
const CircleText = (props: CircleTextProps) => {
  return (
    <CircleContainer>
      <Circle>
        <Text>{props.text}</Text>
      </Circle>
    </CircleContainer>
  );
};


